export default function Features() {
  const features = [
    {
      label: 'Core Feature',
      title: 'Daily Affirmations',
      description: 'Identity-based "I am" statements that reshape your self-talk and build a stronger, more confident mindset from the inside out.',
      icon: 'ri-chat-heart-line',
      gradient: 'from-[#FFE8DC] to-[#FFE4E8]'
    },
    {
      label: 'Reflection',
      title: 'Guided Reflections',
      description: 'Question-based prompts designed to help you think deeper, gain clarity, and understand yourself better.',
      icon: 'ri-lightbulb-line',
      gradient: 'from-[#E8F4FF] to-[#E8F0FF]'
    },
    {
      label: 'Practice',
      title: 'Gratitude Journal',
      description: 'A simple, repeatable flow for everyday gratitude practice that keeps you grounded and appreciative.',
      icon: 'ri-heart-3-line',
      gradient: 'from-[#FFE4E8] to-[#F0E8FF]'
    },
    {
      label: 'Audio',
      title: 'Audio Sessions',
      description: 'Ambient background music paired with spoken affirmations for a calming, immersive experience.',
      icon: 'ri-headphone-line',
      gradient: 'from-[#F0E8FF] to-[#FFE8DC]'
    },
    {
      label: 'Tools',
      title: 'Printables & Journals',
      description: 'Structured tools for people who prefer writing on paper: journals, cards, and worksheets.',
      icon: 'ri-file-text-line',
      gradient: 'from-[#E8F4FF] to-[#FFE4E8]'
    }
  ];

  return (
    <section id="features" className="bg-gradient-to-b from-[#FDFBF7] to-[#F0F4F8] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-3">
            Everything You Need
          </h2>
          <p className="text-lg text-[#5A5A5A] mt-6 max-w-2xl mx-auto">
            A complete toolkit for daily practice, inner alignment, and lasting mindset change.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-10 shadow-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group ${
                index === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="px-3 py-1 bg-[#E8F4FF] text-[#5A5A5A] text-xs font-medium rounded-full transition-colors duration-300">
                  {feature.label}
                </span>
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${feature.gradient} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-xl text-[#2C2C2C]`}></i>
                </div>
              </div>
              <h3 className="text-2xl font-semibold text-[#2C2C2C] mb-4 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-base text-[#5A5A5A] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
